import { logger as garnishLogger } from '@garnish/logger';

// ─── Logger ──────────────────────────────────────────────────────────────────

const log = garnishLogger.extend('ORDERING_MACHINE');

export { log as orderingMachineLog };
